import React, { useReducer, useEffect, useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Logo from '../../Images/ArcaContinental.svg';
import { postData } from '../../Services/apiService';


const actionTypes = {
  TOGGLE_NAVBAR: 'TOGGLE_NAVBAR',
};

const navbarReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_NAVBAR:
      return { ...state, expanded: !state.expanded };
    default:
      return state;
  }
};

const Sidenavbar = ({ userType }) => {
  const initialState = { expanded: false };
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('user')) || {});
  const [isAdmin, setIsAdmin] = useState(user?.isAdmin === 2);

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedUser = JSON.parse(localStorage.getItem('user')) || {};
      setUser(updatedUser);
    };
  
    window.addEventListener('storage', handleStorageChange);
  
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  
  useEffect(() => {
    // Si isAdmin no existe, hacemos el fetch
    if (user && user.isAdmin === undefined) {
      fetchUserData();
    } else {
      setIsAdmin(user?.isAdmin === 2);
    }
  }, [user]);
  
  const fetchUserData = async () => {
    const storedUser = JSON.parse(localStorage.getItem('user')) || {};
    const idUser = storedUser.id || 0;
  
    try {
      const data = await postData('AppUser/GetAppUserById', idUser);
      if (data.succes) {
        const additionalData = data.data;
  
        const updatedUser = {
          ...storedUser,
          ...additionalData,
        };
  
       
        setUser(updatedUser);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };
  const [_state, dispatch] = useReducer(navbarReducer, initialState);

  const toggleNavbar = () => {
    dispatch({ type: actionTypes.TOGGLE_NAVBAR });
  };

  return (
    <Navbar className="sidenavbar">
      <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={toggleNavbar} />
      <Navbar.Brand href="/">
        <img className="d-inline-block align-top logo" src={Logo} alt="Logo ArcaContinental" />
      </Navbar.Brand>

      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav expand="md" className="flex-column">
          {userType === 'super' && (
            <>
              <Nav.Link href="/SuperDashboard">
                <i className="fa-solid fa-house"></i> Dashboard
              </Nav.Link>
              <Nav.Link href="/SuperStatistics">
                <i className="fa-solid fa-chart-line"></i> Estadísticas
              </Nav.Link>
              <Nav.Link href="/SuperUsers">
                <i className="fa-solid fa-users"></i> Usuarios
              </Nav.Link>
            </>
          )}

          {userType === 'admin' && (
            <>
              <Nav.Link href="/AdminDashboard">
                <i className="fa-solid fa-house"></i> Dashboard
              </Nav.Link>
              <Nav.Link href="/AdminStatistics">
                <i className="fa-solid fa-chart-line"></i> Estadísticas
              </Nav.Link>
              <Nav.Link href="/AdminUsers">
                <i className="fa-solid fa-users"></i> Usuarios
              </Nav.Link>
              {isAdmin && (
                <Nav.Link href="/AdminDocuments">
                  <i className="fa-solid fa-file"></i> Documentos
                </Nav.Link>
              )}
            </>
          )}

          {userType === 'manager' && (
            <>
              <Nav.Link href="/ManagerDashboard">
                <i className="fa-solid fa-house"></i> Dashboard
              </Nav.Link>
              <Nav.Link href="/ManagerStatistics">
                <i className="fa-solid fa-chart-line"></i> Estadísticas
              </Nav.Link>
              <Nav.Link href="/ManagerDocuments">
                <i className="fa-solid fa-file-lines"></i> Documentos
              </Nav.Link>
            </>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Sidenavbar;
